/** Locale used for date formatting when the browser locale is unavailable. */
export const DEFAULT_LOCALE = 'en-GB';
